const defaults = {
  // Polling configuration
  pollInterval: '0 */5 * * * *', // Every 5 minutes (with seconds)
  lookbackWindow: 24,
  batchMode: 'batch',
  maxRecordsPerPoll: 100,
  continueOnNoRecords: false,

  // Response parsing
  recordsPath: 'data',
  dateField: 'createdAt',
  idField: 'id',

  // Generic HTTP fallback (when no sub-node connected)
  useGenericHttp: false,
  httpUrl: '',
  httpMethod: 'GET',
  httpHeaders: '',
  httpBody: '',
  httpCredentialId: '',
  httpDateParameterName: '',
  httpDateFormat: 'iso8601',
  httpDateFormatCustom: '',
};

export default defaults;
